export function AccuratLOGO() {
  return (
    <svg
      width="78"
      height="24"
      fill="white"
      viewBox="0 0 44.08 11.65"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Profile_About_Accurat_logo</title>
      <g id="modals">
        <rect x="9.87" width="1.34" height="11.65" />
        <rect x="15.2" width="1.34" height="11.65" />
        <rect x="20.54" width="1.34" height="11.65" />
        <rect x="25.88" width="1.34" height="11.65" />
        <rect x="42.74" width="1.34" height="11.65" />
        <polygon points="3.81 0.17 5 0.17 1.36 11.65 1.41 11.65 5.17 0 3.76 0 0 11.65 0.17 11.65 3.81 0.17" />
        <polygon points="3.81 0.17 0.17 11.65 1.36 11.65 5 0.17 3.81 0.17" />
        <polygon points="36.69 0.17 37.88 0.17 34.23 11.65 34.27 11.65 38.03 0 36.63 0 32.86 11.65 33.04 11.65 36.69 0.17" />
        <polygon points="36.69 0.17 33.04 11.65 34.23 11.65 37.88 0.17 36.69 0.17" />
      </g>
    </svg>
  )
}
